import type { LibraryCandidateKind, LibrarySource } from './types';

export type CandidateOrigin = 'applied' | 'saved' | 'uploaded' | 'email';

export const CANDIDATE_ORIGINS: CandidateOrigin[] = [
  'applied',
  'saved',
  'uploaded',
  'email',
];

export function getCandidateOrigin(
  kind: LibraryCandidateKind,
  source: LibrarySource,
): CandidateOrigin {
  if (kind === 'applicant') return 'applied';
  if (source === 'upload' || source === 'scan') return 'uploaded';
  if (source === 'email') return 'email';
  return 'saved';
}
